import { Component, OnInit,Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadImagesComponent } from './../upload-images/upload-images.component';
import { ActivatedRoute } from '@angular/router';
import { NotificationServiceService } from './../../../../../../../../../services/notification-service/notification-service.service';
import { ContenedoresService } from './../../../../../../../../../services/API/contenedores/contenedores.service';
import { ViewFotoComponent } from './../view-foto/view-foto.component';

@Component({
    selector: 'app-gallery',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.css'],
    standalone: false
})
export class GalleryComponent implements OnInit {

  loadingBar: boolean = true;
  @Input() id: any = null;
  @Input() tipo: any = null;
  path: string = "/imatges/contenedores";
  images: any = [];

  constructor(private route: ActivatedRoute, private dialog: MatDialog, private ContenedoresService: ContenedoresService, private notificationService: NotificationServiceService) { }

  ngOnInit(): void {
    this.getImages();
  }

  uploadImage(){
    if(this.id  !== null && this.tipo  !== null){
      const dialog = this.dialog.open(UploadImagesComponent, {
        width: '500px',
        maxWidth: '90%',
        data: {'path': this.path, 'tipo': this.tipo, 'id': this.id, 'maxImages': 999},
      });
      dialog.afterClosed().subscribe(result => {
        this.getImages();
      });
    }
  }

  getImages() {
    if(this.id  !== null && this.tipo  !== null){
      this.loadingBar = true;
      this.ContenedoresService.getImages(this.tipo, this.id).subscribe(result => {
        var imagesNew = result;
        for(var i=0; i < Object.keys(imagesNew).length; i++){
          imagesNew[i]['foto'] = this.generateURL(imagesNew[i]['foto']);
        }
        this.images = imagesNew;
        this.loadingBar = false;
      }, error => {
        this.loadingBar = false;
        this.notificationService.openSnackBar("❌ Se ha producido un error.");
      });
    }
  }

  generateURL(url: string){
    var hash = "nmSIMK1ojcwOdnmSIMK1ojcwOdgLGkZhmsuRsaByNx5DngLGkZhmsuRsaByNx5Dn";
    return "https://api2.retsl.com/storage/contenedores/" + hash + "/" + url;
  }

  openImageBig(foto: string, fecha: string, id) {
    const viewDialog = this.dialog.open(ViewFotoComponent, {
      data: {foto: foto, fecha: fecha, tipo: this.tipo, id: id},
    });
    viewDialog.afterClosed().subscribe(result => {
      if(result === 'delete'){
        this.getImages();
      }
    });
  }

}
